"use client";

import { useQuery } from "@tanstack/react-query";
import { useState, useEffect } from "react";
import DropdownSelect from "../../../components/admin/common/DropDownSelect";
import Header from "../../../components/admin/common/Header";
import PageWrapper from "../../../components/admin/common/PageWrapper";
import Sidebar from "../../../components/admin/common/Sidebar";
import Pagination from "../../../components/admin/common/Pagination";
import { DesignationListTable } from "../../../components/admin/designation/DesignationListTable";
import { getAllDesignations } from "../../../services/designationServices";
import { useUserModulePermissions } from "../../../hooks/useUserModulePermissions";
import { getCookie } from "../../../utils";

const DesignationList = () => {
  const [entriesOption, setEntriesOption] = useState({
    value: 10,
    label: "10",
  });
  const [lastIds, setLastIds] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [designationList, setDesignationList] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [nextLastId, setNextLastId] = useState(null);

  const currentLastId =
    currentIndex > 0 ? lastIds[currentIndex - 1] : undefined;

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["designations", currentLastId, entriesOption.value],
    queryFn: () => getAllDesignations(currentLastId, entriesOption.value),
    keepPreviousData: true,
  });

  useEffect(() => {
    if (data?.data?.data) {
      setDesignationList(data.data.data);
      setHasMore(data.data.pagination?.hasNext || false);
      setNextLastId(data.data.pagination?.lastId || null);
    }
  }, [data]);

  const handleNext = () => {
    if (hasMore && nextLastId) {
      const updated = [...lastIds];
      updated[currentIndex] = nextLastId;
      setLastIds(updated);
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  const handleEntriesChange = (option) => {
    setEntriesOption(option);
    setCurrentIndex(0);
    setLastIds([]);
  };

  const role = getCookie("role");
  const userId = getCookie("userId");

  const { data: permissionsData } = useUserModulePermissions(
    "Designation List",
    userId,
    {
      enabled: role === "maintainer" && userId && userId !== "undefined",
    }
  );
  console.log(permissionsData, "permissionsData");

  return (
    <div className="flex h-screen p-4 gap-4 bg-white overflow-hidden">
      <div className="h-full">
        <Sidebar />
      </div>

      <div className="flex-1 h-full bg-[#F3EFFF] rounded-[27px] overflow-hidden">
        <PageWrapper>
          <div className="flex flex-col h-full">
            <div className="flex-1 p-4 overflow-y-auto">
              <Header
                title="Designation"
                desc="Manage and view all designations"
              />

              <DropdownSelect
                selected={entriesOption}
                onChange={handleEntriesChange}
              />

              {isLoading ? (
                <p className="mt-4 text-center">Loading designations...</p>
              ) : isError ? (
                <p className="mt-4 text-center text-red-500">
                  Failed to fetch: {error.message}
                </p>
              ) : (
                <DesignationListTable
                  data={designationList}
                  refetch={refetch}
                  startIndex={currentIndex * entriesOption.value}
                  permissionsData={permissionsData?.data ?? null}
                />
              )}

              <div className="h-5" />
              <Pagination
                currentPage={currentIndex + 1}
                hasMore={hasMore}
                onPrevious={handlePrevious}
                onNext={handleNext}
              />
              <div className="h-5" />
            </div>
          </div>
        </PageWrapper>
      </div>
    </div>
  );
};

export default DesignationList;
